import React from 'react';

import './AnnotationShortcutHint.less';

function AnnotationShortcutHint() {
  return (
    <div className="annotation_shortcut_hint">
      <div className="annotation_shortcut_hint__text">
        <div className="annotation_shortcut_hint__key">Space</div> Play/Pause{' '}
      </div>
      <div className="annotation_shortcut_hint__text">
        <div className="annotation_shortcut_hint__key">D</div> Annotate
      </div>
      <div className="annotation_shortcut_hint__text">
        <div className="annotation_shortcut_hint__key">C</div> Comment
      </div>
    </div>
  );
}

export default AnnotationShortcutHint;
